import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl } from '@material-ui/core';
import MuiPhoneNumber from 'material-ui-phone-number';
import useReactHookFormStyles from '../../../../custom-components/form-components/ReactHookForm.styles';
import PermissionsSelector from '../../../../custom-widgets/PermissionsSelector/PermissionSelector';

/**
 * react-hook-form compatible permission selector, wraps the original PermissionsSelector component
 */
const PermissionSelector = ({ name, props: { permissionsSet, rules, type } }) => {
    const classes = useReactHookFormStyles();
    const { control } = useFormContext();

    return (
        <FormControl className={type !== 'hidden' && classes.formController}>
            <Controller name={name} control={control} rules={rules} render={({ field }) => <PermissionsSelector permissionType={permissionsSet} handlePermissionChange={(p) => field.onChange([...p])} selectedValues={field.value ?? []} />} />
        </FormControl>
    );
};

export default PermissionSelector;
